'use strict'

import common from 'assets/themes/campings/js/page/common/index'

export default function (): void {
  const resultsEl = document.getElementById('results')

  if (!resultsEl) {
    return
  }

  if (!common.isMobile() && !common.isTablet()) {
    const filterPageEl = document.getElementById('filter_offers_page') as HTMLInputElement
    if (filterPageEl) {
      filterPageEl.value = '1'
    }

    document.getElementById('filter_offers_filter')?.click()

    resultsEl.dispatchEvent(new CustomEvent('loading.show'))
  }
}
